<!-- prettier-ignore -->
<div class="content-expandable" #inputExpandable>
  <div class="input-expandable" [ngClass]="{ 'focus': panel.expanded() }" (click)="openPanel()" >
    <div class="content-label">
      <label mb-form-field-label>Visitantes</label>
      <span>
        {{ visitantes.adultos }} adultos , {{ visitantes.ninios }} niños,
        {{ visitantes.bebes }} bebes
      </span>
    </div>

    <button class="button-expandable" [mb-expandable-panel]="panel" (click)="openPanel()">
      <span *ngIf="panel.expanded()"><mb-icon icon="arrow-up"></mb-icon></span>
      <span *ngIf="!panel.expanded()"><mb-icon icon="arrow-down"></mb-icon></span>
    </button>
  </div>
  <mb-expandable-panel #panel class="expandable">
    <increment-input [disable]="true" [formGroup]="formControlInput" formName="adults"><span title >Adultos</span> <span label>A partir de 12 años*</span>
    </increment-input>
    <increment-input [disable]="true" [formGroup]="formControlInput" formName="childs" ><span title >Menores</span> <span label>De 2 a 12 años*</span></increment-input>
    <increment-input [disable]="true" [formGroup]="formControlInput" formName="babys"><span title >Bebés</span> <span label>Menos de 2 años*</span></increment-input>
  </mb-expandable-panel>
</div>
